<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.dictName" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新增类别
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="dictName" label="类别名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="dictCode" label="类别编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip></el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.page" :page-size="listQuery.limit" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增类别': operation == 'edit' ? '编辑类别':'查看类别'" @close="onCancel" :visible.sync="dialogVisible" :width="'20%'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <!-- <el-form-item class="mb-30" prop="dictType">
            <el-input v-model="addForm.dictType" disabled placeholder="请输入类别名称" />
          </el-form-item> -->

          <el-form-item class="mb-30" prop="dictName">
            <el-input v-model="addForm.dictName" placeholder="请输入类别名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="dictCode">
            <el-input v-model="addForm.dictCode" placeholder="请输入类别code" />
          </el-form-item>

          <el-form-item class="mb-30" prop="dictOrder">
            <el-input v-model="addForm.dictOrder" placeholder="请输入顺序" />
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      form: {
        dictName: '',
      },
      addForm: {
        dictType: 'activity_type',
        pid: -1,
      },

      loadingSave: false,
      operation: 'add',
      rules: {
        dictName: [{ required: true, message: '活动类别名称不能为空', trigger: 'blur' }],
        dictCode: [{ required: true, message: '活动类别编码不能为空', trigger: 'blur' }],
      },

      configData: {
        tableName: 'collect'
      },
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getDicData() {
      this.tableData = []
      this.listLoading = true
      this.$http.get('collectDict/getSysDictList', { dictType: 'activity_type', ...this.form, ...this.listQuery }).then(res => {
        this.listLoading = false
        if (res.data && res.data.length > 0) {
          this.tableData = res.data
          this.total = res.count
        }
      })

      // this.$http
      //   .get('/collectDict/getSelectDataByKey', { key: 'video_type' })
      //   .then(res => {
      //     this.listLoading = false
      //     if (res.success) {
      //       var result = res.result
      //       this.tableData = result
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },

    // 重置查询
    resetForm(formName) {
      this.form = {
        dictName: '',
      }
      this.listQuery.page = 1
      this.getDicData()
    },

    // 查询
    getTableList() {
      this.listQuery.page = 1
      this.getDicData()
    },

    // 新增
    handleAdd() {
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$http.get('collectDict/deleteSysDict', { dictId: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getDicData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {
        dictType: 'activity_type',
        pid: -1,
      }
      this.$refs["form"].clearValidate()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getDicData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getDicData()
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "collectDict/addSysDict",
            method = "post"
          if (this.addForm.id) {
            url = "collectDict/updateSysDict"
            method = "get"
          }
          if (this.addForm.createDate) {
            delete this.addForm.createDate
          }
          this.$http[method](url, this.addForm).then(res => {
            this.loadingSave = false

            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '活动类别修改成功' : '活动类别新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getDicData()
                }
              })
            } else {
              this.$message.error(this.addForm.id ? '活动类别修改失败' : '活动类别新增失败')
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

  },
  created() {
    // this.getData()

    this.getDicData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>